import React, { useEffect } from "react";
import styles from "./index.module.css";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.bgColor}>
      <div className="main-container">
        <div className="container-content">
          <div className="card-section">
            <div className="main-card">
              <h1 className={`form-title ${styles.title}`}>
                Terms and Conditions
              </h1>
              <div className={styles.termsContent}>
                <p>
                  Welcome to{" "}
                  <a
                    href="https://www.studyhub.lk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.footerLink}
                  >
                    studyhub.lk
                  </a>
                </p>
                <p>
                  We strongly encourage you to carefully review and comprehend these Terms
                  and Conditions to ensure that you fully grasp the terms governing the
                  use of the Website before availing yourself of the services provided via
                  the Platform. Additionally, we recommend checking this page regularly to
                  stay updated on any amendments made to these Terms.
                </p>
                <p>
                  THESE TERMS AND CONDITIONS {`("Terms")`} TAKE EFFECT FROM: 16/11/2025
                </p>
                <p>
                  THIS AGREEMENT IS BETWEEN YOU OR THE ENTITY YOU REPRESENT (referred to
                  as “You” or “Your”) AND STUDY HUB, (referred to as “Website” or
                  “we”).
                </p>
                <h3>Description of Service</h3>
                <p>
                  Study Hub stands as an educational platform dedicated to
                  cultivating empowered and skilled individuals for the betterment of Sri
                  Lanka. We allow users to purchase educational videos and courses.
                </p>
                <h4>1. Refund Policy</h4>
                <p>
                  The Study Hub provides a collection of services, some of which are
                  free and some are paid. Users must complete the payment process before
                  accessing any paid content.
                </p>
                <p>
                  Payments can only be processed through the Payhere payment gateway using
                  credit or debit cards. Please be aware that these payment gateways are
                  independent and governed by their terms and privacy policies. We
                  strongly recommend that users familiarize themselves with these policies
                  before using our payment services.
                </p>
                <p>
                  We reserve the right to modify the pricing of any service or content
                  offered for a fee or introduce charges for currently free services.
                  Users must comply with any fee adjustments, and decisions made by the
                  company regarding fees are final. While we make every effort to inform
                  users of any changes in pricing, adjustments will not apply
                  retroactively.
                </p>
                <p>
                  Please note that we do not provide refunds for payments made under any
                  circumstances. If your account is suspended or terminated, any prior
                  payments made will not be refunded.
                </p>
                <p>
                  If you have any payment-related inquiries or concerns, please contact us
                  via the information provided in the website.
                </p>

                <h4>2. Terms and Conditions</h4>
                <p>
                  Welcome to the Studyhub website. These Terms and Conditions govern
                  your use of our website and the purchase from our platform. By accessing
                  and using our website, you agree to comply with these terms. Please read
                  them carefully before proceeding with any transactions.
                </p>
                <h4>Use of the Website</h4>
                <ol type="a">
                  <li>
                    To accept the terms and conditions, you must have attained the legal
                    age to enter into a legally binding agreement. Users under the age of
                    majority should use the Website with the guidance of a legal guardian
                    when making payments.
                  </li>
                  <li>
                    You are responsible for maintaining the confidentiality of your
                    account information, including your username and password.
                  </li>
                  <li>
                    You agree to provide accurate and current information during the
                    registration and checkout process.
                  </li>
                  <li>
                    You may not use our website for any unlawful or unauthorized purposes.
                  </li>
                </ol>
                <h4>Product Information and Pricing</h4>
                <ol type="a">
                  <li>
                    We strive to provide accurate service descriptions, images, and
                    pricing information. However, we do not guarantee the accuracy or
                    completeness of such information.
                  </li>
                  <li>
                    Prices are subject to change without notice. Any promotions or
                    discounts are valid for a limited time and may be subject to
                    additional terms and conditions.
                  </li>
                </ol>
                <h4>Orders and Payments</h4>
                <ol type="a">
                  <li>
                    By placing an order on our website, you are making an offer to
                    purchase the selected products.
                  </li>
                  <li>
                    You agree to provide valid and up-to-date payment information and
                    authorize us to charge the total order amount, including applicable
                    taxes, to your chosen payment method.
                  </li>
                  <li>
                    We use trusted third-party payment processors to handle your payment
                    information securely. We do not store or have access to your full
                    payment details.
                  </li>
                </ol>
                <h4>Returns and Refunds</h4>
                <ol type="a">
                  <li>
                    We do not provide refunds for payments made under any circumstances.
                    If your account is suspended or terminated, any prior payments made
                    will not be refunded.
                  </li>
                </ol>
                <h4>Intellectual Property</h4>
                <ol>
                  <li>
                    All content and materials on our website, including but not limited to
                    text, images, logos, and graphics, are protected by intellectual
                    property rights and are the property of Studyhub or its
                    licensors.
                  </li>
                  <li>
                    You may not use, reproduce, distribute, or modify any content from our
                    website without our prior written consent.
                  </li>
                </ol>
                <h4>Limitation of Liability</h4>
                <ol type="a">
                  <li>
                    In no event shall Studyhub, its directors, employees, or
                    affiliates be liable for any direct, indirect, incidental, special, or
                    consequential damages arising out of or in connection with your use of
                    our website or the purchase and use of our services.
                  </li>
                  <li>
                    We make no warranties or representations, express or implied,
                    regarding the quality, accuracy, or suitability of the services
                    offered on our website.
                  </li>
                </ol>
                <h4>Amendments and Termination</h4>
                <p>
                  We reserve the right to modify, update, or terminate these Terms and
                  Conditions at any time without prior notice. It is your responsibility
                  to review these terms periodically for any changes.
                </p>

                <h2>Intellectual Property</h2>
                <ul>
                  <li>
                    All content and materials on our website, including but not
                    limited to courses, videos, text, images, logos, and graphics, are protected
                    by intellectual property rights and are the property of{" "}
                    <a
                      href="https://www.studyhub.lk/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.footerLink}
                    >
                      studyhub.lk
                    </a>{" "}
                    or its licensor Ardillalbs Private Limited.
                  </li>
                  <li>
                    You may not use, reproduce, distribute, or modify any
                    content from our website without our prior written consent.
                  </li>
                </ul>

                <h2>Limitation of Liability</h2>
                <ul>
                  <li>
                    In no event shall{" "}
                    <a
                      href="https://www.studyhub.lk/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.footerLink}
                    >
                      studyhub.lk
                    </a>{" "}
                    and its directors, employees, or affiliates be liable for
                    any direct, indirect, incidental, special, or consequential
                    damages arising out of or in connection with your use of our
                    website or the purchase and use of our products.
                  </li>
                  <li>
                    We make no warranties or representations, express or
                    implied, regarding the quality, accuracy, or suitability of
                    the products offered on our website.
                  </li>
                </ul>

                <h2>Amendments and Termination</h2>
                <p>
                  We reserve the right to modify, update, or terminate these
                  Terms and Conditions at any time without prior notice. It is
                  your responsibility to review these terms periodically for any
                  changes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
